import {observer} from 'mobx-react';
import {Panel} from 'shared/components';
import {DependantFields} from 'main/components/benefits';
import {t} from 'shared/core';

const Dependents = observer(({uiState}) => {
  const {benefitInfo, errors} = uiState;

  return (
    <div>
      <Panel.Header title={t('benefits.benefit_info.edit.steps.Dependants')}/>
      <DependantFields benefitInfo={benefitInfo} errors={errors.updatedBenefitInfo}/>
    </div>
  );
});

export default Dependents;
